import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputFileWithCommentCommentComponent } from './input-file-with-comment-comment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';



@NgModule({
  declarations: [
    InputFileWithCommentCommentComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AngularMaterialModule,
    DialogContainerModule
  ]
})
export class InputFileWithCommentCommentModule { }
